module.exports = __webpack_public_path__ + "static/media/server.7836db80.svg";